import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=826c110c&scoped=true&"
import script from "./ChangePhone.vue?vue&type=script&lang=ts&"
export * from "./ChangePhone.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=826c110c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826c110c",
  null
  
)

export default component.exports